import { render, staticRenderFns } from "./EventDetailModal.vue?vue&type=template&id=3953bb46"
import script from "./EventDetailModal.vue?vue&type=script&lang=js"
export * from "./EventDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports